import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Observable, of as observableOf } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { DialogService } from '../../dialogs/dialogs.service';
import { ProtectedControlsDialogComponent } from '../../dialogs/protected-controls-dialog/protected-controls-dialog.component';
import { ProtectedControlsService } from './protected-controls.service';

@Injectable({ providedIn: 'root' })
export class ProtectedControlsGuardService {
  /**
   * If navigation is redirected canDeactivate can be called multiple times, so we need to save
   * information that user allowed to leave the page to avoid multiple ProtectedControls dialog openings
   * for each redirect.
   */
  private deactivatedSnapshotsMap = new WeakMap<ActivatedRouteSnapshot, boolean>();

  constructor(
    private protectedControls: ProtectedControlsService,
    private dialogService: DialogService,
  ) {}

  public canDeactivate(
    _cmpInstance: any,
    currentSnapshot: ActivatedRouteSnapshot,
  ): Observable<boolean> {
    const { locked, reports } = this.protectedControls;
    const isDeactivated = !!this.deactivatedSnapshotsMap.get(currentSnapshot);
    if (
      locked &&
      !isDeactivated &&
      !reports.every(
        report => report.name === '<p><br /></p>' && report.newValue === '<p><br /></p>',
      )
    ) {
      return this.dialogService
        .openCustom(ProtectedControlsDialogComponent, {}, {})
        .afterClosed.pipe(
          map(result => !!result),
          first(),
          tap(result => {
            if (result) {
              this.deactivatedSnapshotsMap.set(currentSnapshot, true);
            }
          }),
        );
    } else {
      return observableOf(true);
    }
  }
}
